"use strict";

var _classCallCheck = require("/home/runner/work/jaeger/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/jaeger/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/runner/work/jaeger/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/jaeger/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/runner/work/jaeger/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _types = require("./types");

var _utils = require("./utils");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
} // Copyright (c) 2019 Uber Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.


var SVG_HIDDEN_STYLE = {
  visibility: 'hidden'
};

var MeasurableNode =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(MeasurableNode, _React$PureComponent);

  function MeasurableNode() {
    var _this;

    _classCallCheck(this, MeasurableNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MeasurableNode).apply(this, arguments));
    _this.htmlRef = React.createRef();
    _this.svgRef = React.createRef();
    return _this;
  }

  _createClass(MeasurableNode, [{
    key: "measureHtml",
    value: function measureHtml() {
      var current = this.htmlRef.current;

      if (!current) {
        return {
          height: 0,
          width: 0
        };
      }

      return {
        height: current.offsetHeight,
        width: current.offsetWidth
      };
    }
  }, {
    key: "measureSvg",
    value: function measureSvg() {
      var current = this.svgRef.current;

      if (!current) {
        return {
          height: 0,
          width: 0
        };
      }

      var _current$getBBox = current.getBBox(),
          height = _current$getBBox.height,
          width = _current$getBBox.width;

      return {
        height: height,
        width: width
      };
    }
  }, {
    key: "renderHtml",
    value: function renderHtml() {
      var _this$props = this.props,
          getClassName = _this$props.getClassName,
          hidden = _this$props.hidden,
          renderNode = _this$props.renderNode,
          renderUtils = _this$props.renderUtils,
          setOnNode = _this$props.setOnNode,
          vertex = _this$props.vertex,
          layoutVertex = _this$props.layoutVertex;

      var _ref = layoutVertex || {},
          _ref$height = _ref.height,
          height = _ref$height === void 0 ? null : _ref$height,
          _ref$left = _ref.left,
          left = _ref$left === void 0 ? null : _ref$left,
          _ref$top = _ref.top,
          top = _ref$top === void 0 ? null : _ref$top,
          _ref$width = _ref.width,
          width = _ref$width === void 0 ? null : _ref$width;

      var props = (0, _utils.assignMergeCss)({
        className: getClassName('MeasurableHtmlNode'),
        style: {
          height: height,
          width: width,
          boxSizing: 'border-box',
          position: 'absolute',
          transform: left == null || top == null ? undefined : "translate(".concat(left.toFixed(), "px,").concat(top.toFixed(), "px)"),
          visibility: hidden ? 'hidden' : undefined
        }
      }, (0, _utils.getProps)(setOnNode, vertex, renderUtils, layoutVertex));
      return React.createElement("div", Object.assign({
        ref: this.htmlRef
      }, props), renderNode(vertex, renderUtils, layoutVertex));
    }
  }, {
    key: "renderSvg",
    value: function renderSvg() {
      var _this$props2 = this.props,
          getClassName = _this$props2.getClassName,
          hidden = _this$props2.hidden,
          renderNode = _this$props2.renderNode,
          renderUtils = _this$props2.renderUtils,
          setOnNode = _this$props2.setOnNode,
          vertex = _this$props2.vertex,
          layoutVertex = _this$props2.layoutVertex;

      var _ref2 = layoutVertex || {},
          _ref2$left = _ref2.left,
          left = _ref2$left === void 0 ? null : _ref2$left,
          _ref2$top = _ref2.top,
          top = _ref2$top === void 0 ? null : _ref2$top;

      var props = (0, _utils.assignMergeCss)({
        className: getClassName('MeasurableSvgNode'),
        transform: left == null || top == null ? undefined : "translate(".concat(left.toFixed(), ", ").concat(top.toFixed(), ")"),
        style: hidden ? SVG_HIDDEN_STYLE : null
      }, (0, _utils.getProps)(setOnNode, vertex, renderUtils, layoutVertex));
      return React.createElement("g", Object.assign({
        ref: this.svgRef
      }, props), renderNode(vertex, renderUtils, layoutVertex));
    }
  }, {
    key: "getRef",
    value: function getRef() {
      if (this.props.layerType === _types.ELayerType.Html) {
        return {
          htmlWrapper: this.htmlRef.current,
          svgWrapper: undefined
        };
      }

      return {
        svgWrapper: this.svgRef.current,
        htmlWrapper: undefined
      };
    }
  }, {
    key: "measure",
    value: function measure() {
      return this.props.layerType === _types.ELayerType.Html ? this.measureHtml() : this.measureSvg();
    }
  }, {
    key: "render",
    value: function render() {
      var layerType = this.props.layerType;

      if (layerType === _types.ELayerType.Html) {
        return this.renderHtml();
      }

      return this.renderSvg();
    }
  }]);

  return MeasurableNode;
}(React.PureComponent);

exports.default = MeasurableNode;